export default __webpack_public_path__ + "PP.png";